import React, { FC, useState } from 'react';

import hasTouch from 'common/tools/dom/getTouchBrowser';

type HoverProps = {
  children: FC<{ isHovered: boolean }>;
  forceHoverOnTouchDevices?: boolean;
};

const Hover = ({ children, forceHoverOnTouchDevices = true }: HoverProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
      className="userspace-hover-container"
    >
      {children({
        isHovered: forceHoverOnTouchDevices && hasTouch() ? true : isHovered
      })}
    </div>
  );
};

export default Hover;
